module.exports = __webpack_public_path__ + "media/images/avatar-male-f00730be9155f0fbc9d8dedf535c510b.png";